module.exports = __webpack_public_path__ + "img/logo_full2_white.e0d85524.png";